"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

var _utils = require("@material-ui/core/utils");

var _Selector = _interopRequireDefault(require("./Selector.styles"));

var _excluded = ["children", "onClick", "disabled", "selected", "className", "id"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Selector = /*#__PURE__*/(0, _react.forwardRef)(function Selector(_ref, ref) {
  var _classnames;

  var children = _ref.children,
      onClick = _ref.onClick,
      disabled = _ref.disabled,
      selected = _ref.selected,
      className = _ref.className,
      id = _ref.id,
      allProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useIsFocusVisible = (0, _utils.useIsFocusVisible)(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref; // Internet Explorer & Safari support for :focus-visible


  var handleRef = (0, _utils.useForkRef)(focusVisibleRef, ref);

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      focusVisible = _React$useState2[0],
      setFocusVisible = _React$useState2[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var classes = (0, _Selector.default)();
  var selectorClasses = (0, _classnames2.default)(className, classes.root, (_classnames = {}, (0, _defineProperty2.default)(_classnames, classes.disabled, disabled), (0, _defineProperty2.default)(_classnames, classes.selected, selected && !disabled), (0, _defineProperty2.default)(_classnames, classes.focusVisible, focusVisible), _classnames));

  var onFocus = function onFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
  };

  var onBlur = function onBlur(event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }
  };

  return /*#__PURE__*/_react.default.createElement("label", {
    className: selectorClasses,
    htmlFor: id
  }, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    ref: handleRef,
    type: "radio",
    id: id,
    className: classes.input,
    checked: selected,
    onChange: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled
  }, allProps)), children);
});
Selector.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.node,

  /**
   * Callback fired when a "click" event is detected.
   */
  onClick: _propTypes.func,

  /**
   * If true, the selector will be disabled.
   */
  disabled: _propTypes.bool,

  /**
   * If true, the selector will have the selected style.
   */
  selected: _propTypes.bool,

  /**
   * The id of the input element.
   */
  id: _propTypes.string,

  /**
   * The CSS class name of the wrapper element.
   */
  className: _propTypes.string
};
Selector.defaultProps = {
  children: null,
  onClick: function onClick() {},
  disabled: false,
  selected: undefined,
  id: null,
  className: ''
};
var _default = Selector;
exports.default = _default;
